/* eslint-disable react/no-multi-comp */
import React from "react"
import { css } from "@jsUtils"
import { Headline } from "@shared"
import styles from "@pageStyles/resources.module.scss"
import ResourcesArticle from "./ResourcesArticle"

const ResourcesArticles = ({ items, pagination }) => {
  // clone items to prevent directly mutating a prop
  let articles = items.slice()

  // catch no articles matching the current filter
  if (articles.length === 0) {
    return (
      <Headline className={styles.articlesEmpty} size={4}>
        There&apos;s nothing here yet.
        <br />
        Check back soon.
      </Headline>
    )
  }

  // handle featured article
  // it should appear regardless of pagination
  let featured = null

  const featuredIndex = articles.findIndex(article => article.featuredArticle === true)
  const hasFeatured = featuredIndex !== -1

  if (hasFeatured) {
    featured = articles[featuredIndex]
    articles = articles.filter((_, index) => index !== featuredIndex)
  }

  // apply pagination
  // array index is 0-based, so add 1 to it before comparing it to the pagination limit
  articles = articles.filter((_, index) => index + 1 <= pagination)

  return (
    <div className={css(styles.articles, hasFeatured && styles.hasFeatured)}>
      {hasFeatured && <ResourcesArticle article={featured} featured />}
      {articles.map(article => (
        <ResourcesArticle article={article} key={article.id} />
      ))}
    </div>
  )
}

export default ResourcesArticles
